const state = {
  filterType: "AD",
  isShow: false,
  loading: false,
  items: [],
  isADNum: 0,
  isBadNum: 0,
  checkkeywordscount:0,
  iscount:0,
  checkkeywords:'',
  isListShow:false
};

const mutations = {};

const actions = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};




// WEBPACK FOOTER //
// ./src/store/prohibitedWords.js